import { configureStore } from '@reduxjs/toolkit'
import { authSlice } from './slices/auth'
import { postSlice } from './slices/posts'
import { documentsSlice } from './slices/documents'
import { userRequestsSlice } from './slices/userRequests'
import { bankSlice } from './slices/bank/bankSlice'

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['payload.buildRowData'],
      },
    }),
  reducer: {
    auth: authSlice.reducer,
    posts: postSlice.reducer,
    documents: documentsSlice.reducer,
    userRequests: userRequestsSlice.reducer,
    bank: bankSlice.reducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch